import Vue from 'vue/dist/vue.esm'

Vue.component("bin-card-description-vue", () => import(/* webpackChunkName: "[request]" */ "components/bin_card/BINCardDescription"))
Vue.component("bin-card-vue", () => import(/* webpackChunkName: "[request]" */ "components/bin_card/BINCard"))
Vue.component("bin-card-documents-vue", () => import(/* webpackChunkName: "[request]" */ "components/bin_card/BINCardDocuments"))
Vue.component("bin-card-related-list-vue", () => import(/* webpackChunkName: "[request]" */ "components/bin_card/BINCardRelatedList"))
